import { render } from "./NewBill.vue?vue&type=template&id=8995c848&scoped=true"
import script from "./NewBill.vue?vue&type=script&lang=js"
export * from "./NewBill.vue?vue&type=script&lang=js"

import "./NewBill.vue?vue&type=style&index=0&id=8995c848&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8995c848"]])

export default __exports__